import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { fmtMoney } from "@/lib/api";

export default function DeleteFacturaDialog({ delTarget, isVenta, onCancel, onConfirm }) {
  return (
    <AlertDialog open={!!delTarget} onOpenChange={(v) => !v && onCancel()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="font-heading">
            {isVenta && !delTarget?.cae ? "Anular con Nota de Crédito X" : "Eliminar comprobante"}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {isVenta && !delTarget?.cae ? (
              <>
                Se generará una <span className="font-mono font-semibold">NOTA DE CREDITO X</span> auto-numerada que anulará{" "}
                <span className="font-mono">{delTarget?.tipo_comprobante} {delTarget?.numero}</span> de{" "}
                {delTarget?.contraparte_nombre}.<br />
                Ambos comprobantes permanecerán en el listado por separado (el original queda en estado <b>anulada</b>).<br />
                El saldo del cliente se compensará en{" "}
                <span className="font-mono font-semibold">{fmtMoney(delTarget?.total || 0)}</span>.
              </>
            ) : (
              <>
                ¿Eliminar <span className="font-mono">{delTarget?.tipo_comprobante} {delTarget?.numero}</span> de{" "}
                {delTarget?.contraparte_nombre}?<br />
                El saldo del {isVenta ? "cliente" : "proveedor"} se revertirá en{" "}
                <span className="font-mono font-semibold">{fmtMoney(delTarget?.total || 0)}</span>.
              </>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="rounded-sm">Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className="rounded-sm bg-red-600 hover:bg-red-700" data-testid="confirm-delete-btn">
            {isVenta && !delTarget?.cae ? "Generar NC X" : "Eliminar"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
